import { render, staticRenderFns } from "./ProductPropertiesLarge.vue?vue&type=template&id=52623326&scoped=true"
import script from "./ProductPropertiesLarge.vue?vue&type=script&lang=js"
export * from "./ProductPropertiesLarge.vue?vue&type=script&lang=js"
import style0 from "./ProductPropertiesLarge.vue?vue&type=style&index=0&id=52623326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52623326",
  null
  
)

export default component.exports